import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// MUI Pickers
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtil from '@date-io/moment';

// Contexts
// import LocationManager from "./contexts/LocationManager.Context";
// import JourneyManager from "./contexts/JourneyManager.Context";
// import PatientManager from "./contexts/PatientManager.Context";
// import BookingManager from "./contexts/BookingManager.Context";
// import PaymentManager from "./contexts/PaymentManager.Context";
// import AppointmentTypeManager from "./contexts/AppointmentTypeManager.Context";
// import AppointmentManager from "./contexts/AppointmentManager.Context";
// import CalendarManager from "./contexts/CalendarManager.Context";
// import DoctorManager from "./contexts/DoctorManager.Context";
import ApplicationManager from './contexts/ApplicationManager.Context';
import {
	createGenerateClassName,
	StylesProvider,
} from '@material-ui/core/styles';

const generateClassName = createGenerateClassName({
	seed: 'BookingWidget',
});

ReactDOM.render(
	<React.StrictMode>
		<StylesProvider generateClassName={generateClassName}>
			<MuiPickersUtilsProvider utils={MomentUtil}>
				<ApplicationManager>
					<App wrapper={document.getElementById('booking-widget-v4-root')} />
				</ApplicationManager>
			</MuiPickersUtilsProvider>
		</StylesProvider>
	</React.StrictMode>,
	document.getElementById('booking-widget-v4-root')
);

// ReactDOM.render(
// 	<React.StrictMode>
// 		<MuiPickersUtilsProvider utils={MomentUtil}>
// 			<LocationManager>
// 				<PatientManager>
// 					<AppointmentTypeManager>
// 						<JourneyManager>
// 							<CalendarManager>
// 								<AppointmentManager>
// 									<PaymentManager>
// 										<DoctorManager>
// 											<BookingManager>
// 												<App
// 													wrapper={document.getElementById(
// 														"booking-widget-v4-root"
// 													)}
// 												/>
// 											</BookingManager>
// 										</DoctorManager>
// 									</PaymentManager>
// 								</AppointmentManager>
// 							</CalendarManager>
// 						</JourneyManager>
// 					</AppointmentTypeManager>
// 				</PatientManager>
// 			</LocationManager>
// 		</MuiPickersUtilsProvider>
// 	</React.StrictMode>,
// 	document.getElementById("booking-widget-v4-root")
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
